import { Card, Button, DialogTitle, Snackbar, DialogActions, Backdrop, TableCell, TableContainer, FormControl, Select, Table, Checkbox, FormControlLabel, FormLabel, FormGroup, FormHelperText, TableRow, Box, TableBody, TableHead, Typography, ListItemText, ListItemIcon, ListItem, DialogContent, List, Dialog, CardContent, CardHeader, Container, Grid, IconButton, TextField, TablePagination, Tooltip, Chip, InputAdornment, Autocomplete } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ListItemButton from '@mui/material/ListItemButton';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Divider from '@mui/material/Divider';
import FolderIcon from '@mui/icons-material/Folder';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import Alert from 'src/components/Alert';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import Tarihce from 'src/views/History';
import ExtensionIcon from '@mui/icons-material/Extension';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import UploadFile from '../../components/UploadFile';
import ExpandableComment from 'src/components/ExpandableComment';

const DURUM_RENK = {
  2: { label: 'Findeks Bekliyor', color: '#9c27b0' },
  5: { label: 'BY Onayı Bekliyor', color: '#1976d2' },
  10: { label: 'MOY Onayı Bekliyor', color: '#ed6c02' },
  14: { label: 'Süreç Sonlandırma Bekliyor', color: '#2e7d32' }
};

const FINDEKS_RENK = {
  1: { label: 'Risk Yok', color: '#2e7d32' },
  4: { label: 'Az Riskli', color: '#ed6c02' },
  2: { label: 'Riskli', color: '#d32f2f' },
  3: { label: 'Yüksek Riskli', color: '#b71c1c' }
};

const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  }),
  rootlistsag: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  }),

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  container: {
    maxHeight: '100%',
    maxWidth: '100%',
    minWidth: '100%'
  },
  container1: {
    maxHeight: 630,
    maxWidth: '100%',
    minWidth: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1),
  }),
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  closeButton: (theme) => ({
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1),
    color: theme.palette.grey[500],
  }),
  formControl: (theme) => ({
    margin: theme.spacing(3)
  }),
  cardscontent3: {
    minHeight: 50
  },
  cardscontent2: {
    height: 600
  },
  spanText: {
    lineHeight: 2,
    fontFamily: 'Roboto',
    fontSize: 14
  },
  textInput: {
    border: 'none',
    borderBottom: '1px solid #FF9800',
    padding: '2px 5px',
    outline: 'none',
    fontWeight: 'bold',
  },
  textInput2: {
    border: 'none',
    borderBottom: '1px solid #FF9800',
    padding: '2px 5px',
    outline: 'none',
    boxSizing: 'border-box',
  },
  emailFieldRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
    maxWidth: '100%',
  },
  emailFieldLabel: {
    flexShrink: 0,
  },
  emailInput: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  responsiveContainer: (theme) => ({
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "70vh",
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "60vh",
      overflow: 'scroll'
    }
  })
};
function Confirm() {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();
  const [durumId, setDurumId] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [applicationId, setApplicationId] = useState(0);
  const [documentType, setDocumentType] = useState(0);
  const [Required, setRequired] = useState(false);
  const [yorumAciklama, setYorumAciklama] = useState('');
  const [findeksYorumAciklama, setFindeksYorumAciklama] = useState('');
  const [generalData, setGeneralData] = useState([]);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [filePopUp, setFilePopUp] = useState(false);
  const [fileList, setFileList] = React.useState([])
  const [findeksPopUp, setFindeksPopUp] = useState(false);
  const [findeksInfo, setFindeksInfo] = useState(0)
  const [tarihcePopUp, setTarihcePopUp] = useState(false);
  const [todoData, setTodoData] = useState([]);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState([]);
  const [selectedYSOnay, setSelectedYSOnay] = useState([]);
  const [finalPopUp, setFinalPopUp] = useState(false);
  const [checkedMenu, setCheckedMenu] = useState([]);
  const [moyOnayPopUp, setMoyOnayPopUp] = useState(false);
  const [byOnayPopUp, setBYOnayPopUp] = useState(false);
  const [openType, setOpenType] = useState(0);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [fileTypeData, setFileTypeData] = React.useState([]);
  const [state, setState] = React.useState({
    kural1: false,
    kural2: false,
    kural3: false,
    kural4: false
  });
  const [acilisTipId, setAcilisTipId] = useState(null)
  const [confirmPopUpWithServiceInformation, setConfirmPopUpWithServiceInformation] = useState(false);
  const [confirmServiceAreaName, setConfirmServiceAreaName] = useState('');
  const [confirmServiceOpeningType, setConfirmServiceOpeningType] = useState();
  const [confirmServiceDetailName, setConfirmServiceDetailName] = useState('');
  const [confirmedServiceNumber, setConfirmedServiceNumber] = useState('');
  const [confirmedServiceName, setConfirmedServiceName] = useState('');
  const [confirmedShipmentCode, setConfirmedShipmentCode] = useState('');
  const [confirmedServicePhone, setConfirmedServicePhone] = useState('');
  const [confirmedServicePhone2, setConfirmedServicePhone2] = useState('');
  const [confirmedServiceEmail, setConfirmedServiceEmail] = useState('');
  const [confirmedServiceOwnerEmail, setConfirmedServiceOwnerEmail] = useState('');
  const [serviceType, setServiceType] = useState('');

  const [searchText, setSearchText] = useState('');
  const [filtreAcilisTipi, setFiltreAcilisTipi] = useState(null);
  const [filtreDurum, setFiltreDurum] = useState(null);
  const [filtreBolge, setFiltreBolge] = useState(null);
  const [filtreServisTipi, setFiltreServisTipi] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const acilisTipiSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.ACILIS_TIP).filter(Boolean))]
  ), [generalData]);
  const durumSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.DURUM).filter(Boolean))]
  ), [generalData]);
  const bolgeSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.BOLGE_AD).filter(Boolean))]
  ), [generalData]);
  const servisTipiSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.SERVIS_TIP).filter(Boolean))]
  ), [generalData]);

  const filteredData = useMemo(() => {
    const arama = searchText.trim().toLocaleLowerCase('tr');
    return generalData.filter((row) => {
      if (filtreAcilisTipi && row.ACILIS_TIP !== filtreAcilisTipi) return false;
      if (filtreDurum && row.DURUM !== filtreDurum) return false;
      if (filtreBolge && row.BOLGE_AD !== filtreBolge) return false;
      if (filtreServisTipi && row.SERVIS_TIP !== filtreServisTipi) return false;
      if (!arama) return true;
      const aranacakAlanlar = [row.ACILIS_TIP, row.DURUM, row.SONRAKI_ADIM_ACIKLAMA, row.BOLGE_AD, row.IL_ILCE, row.SERVIS_TIP, row.SERVIS_BILGI];
      return aranacakAlanlar.some((alan) => alan?.toString().toLocaleLowerCase('tr').includes(arama));
    });
  }, [generalData, searchText, filtreAcilisTipi, filtreDurum, filtreBolge, filtreServisTipi]);

  useEffect(() => {
    setPage(0);
  }, [searchText, filtreAcilisTipi, filtreDurum, filtreBolge, filtreServisTipi]);

  const filtreleriTemizle = () => {
    setSearchText('');
    setFiltreAcilisTipi(null);
    setFiltreDurum(null);
    setFiltreBolge(null);
    setFiltreServisTipi(null);
  };

  const filtreAktifMi = Boolean(searchText || filtreAcilisTipi || filtreDurum || filtreBolge || filtreServisTipi);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const { kural1, kural2, kural3, kural4 } = state;

  const Bosalt = () => {
    
    setState({
      kural1: false,
      kural2: false,
      kural3: false,
      kural4: false
    });
    setDurumId(0);
    setApplicationId(0);
    setDocumentType(0);
    setRequired(false);
    setYorumAciklama('');
    setFindeksYorumAciklama('');
    setGeneralData([]);
    setSinglePopUp(false);
    setFilePopUp(false);
    setFileList([]);
    setFindeksPopUp(false);
    setFindeksInfo(0);
    setTarihcePopUp(false);
    setTodoData([]);
    setSelectedWorkOrderId([]);
    setSelectedYSOnay([]);
    setFinalPopUp(false);
    setCheckedMenu([]);
    setMoyOnayPopUp(false);
    setBYOnayPopUp(false);
    setOpenType(0);
    setFileTypeData([]);
    setAcilisTipId(null);
    setConfirmPopUpWithServiceInformation(false);
    setConfirmServiceAreaName('');
    setConfirmServiceOpeningType();
    setConfirmServiceDetailName('');
    setConfirmedServiceNumber('');
    setConfirmedServiceName('');
    setConfirmedShipmentCode('');
    setConfirmedServicePhone('');
    setConfirmedServicePhone2('');
    setConfirmedServiceEmail('');
    setConfirmedServiceOwnerEmail('');
    setServiceType('');
    handleFileClose(1);
    const searchParams1 = new URLSearchParams(window.location.search);
    const myParam1= searchParams1.get('id');
    if (myParam1) {
      setSelectedIndex(parseInt(myParam1));
    }


  }


  useEffect(() => {
    handleFileClose(1);
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('id');
    if (myParam) {
      setSelectedIndex(parseInt(myParam));
    }
    let mounted = true;
    return () => {
      mounted = false;
    };
  }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

  const handleFileClose = (dataUri) => {
    setLoading(true);
    axios.get(`/GetArtemisPortalOnay/${SessionUser.TopServiceShopCode}`)
      .then((response) => {
        setLoading(false);
        const res = response.data;
        setGeneralData(Array.isArray(res) ? res : []);
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleSaveFindeks = (itemValue) => {
    if (findeksInfo == 0) {
      setresponseMessage('Lütfen Findeks Durumunu seçiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (!findeksYorumAciklama) {
      setRequired(true);
      return;
    }
    const data = [{
      Id: selectedIndex,
      FindeksYorum: findeksYorumAciklama,
      UserId: "",//okta
      Role_Id: 0,
      Durum: durumId,
      Findeks_Bilgi: findeksInfo,
      Onay: itemValue
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetFindeksOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setFindeksPopUp(false);
        setFindeksYorumAciklama('');
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setFindeksPopUp(false);
        handleFileClose(1);
        setFindeksYorumAciklama('');
      }
    }).catch(error => {
      setLoading(false);
      setFindeksPopUp(false);
    });
  }

  const handleSave = () => { 
    if (checkedMenu.length < todoData.length && durumId == 14) {
      setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (((durumId == 5 && kural1 == false) || (durumId == 5 && kural2 == false) || (durumId == 5 && kural3 == false) || (durumId == 5 && kural4 == false && serviceType == "Ticari Servis")) && acilisTipId != 5) {
      setresponseMessage("Lütfen BY Onay Adımlarını tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setBYOnayPopUp(true);

      return;
    }
    if (!yorumAciklama) {
      setRequired(true);
      return
    }
    const data = [{
      Id: selectedIndex,
      Yorum: yorumAciklama,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      OpenType: openType
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetArtemisPortalOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
      }
      if (res.ErrorCode === '0') {
      
        setresponseMessage(res.ErrorDescription);
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        Bosalt();
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleSaveWithServiceInformation = () => {
    if (confirmedServiceNumber == '') {
      setresponseMessage("Lütfen Servis Kodu Bilgisini Giriniz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (confirmedServiceName == '') {
      setresponseMessage("Lütfen Servis Adı Bilgisini Giriniz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }
    if (setConfirmedShipmentCode == '') {
      setresponseMessage("Lütfen Yedek Parça Sevkiyat Kodu Bilgisini Giriniz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }
    //servis kodu sadece rakam olmalı
    if (!/^\d+$/.test(confirmedServiceNumber)) {
      setresponseMessage("Servis Kodu Bilgisinde sadece rakam kullanılabilir!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }

    // const nonFormattedConfirmedServicePhone = confirmedServicePhone.replace(/\D/g, '');
    // //check confirmedServicePhone is valid format "(###) ###-####"
    // if (nonFormattedConfirmedServicePhone == '' || nonFormattedConfirmedServicePhone.length != 10) {
    //   setresponseMessage("Girmiş olduğunuz telefon numarası geçersiz!...")
    //   setUyariTip("error");
    //   setUyari(true);
    //   return;
    // }

    //check confirmedServiceEmail is valid email format
    if (confirmedServiceEmail != '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(confirmedServiceEmail)) {
      setresponseMessage("Girmiş olduğunuz e-mail adresi geçersiz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }

    //check confirmedServiceOwnerEmail is valid email format
    if (confirmedServiceOwnerEmail != '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(confirmedServiceOwnerEmail)) {
      setresponseMessage("Girmiş olduğunuz ys sahibi e-mail adresi geçersiz!...")
      setUyariTip("error");
      setUyari(true);
      return;
    }




    var comment = '';
    confirmServiceOpeningType == "Yeni Açılış"
      ? comment = `${confirmServiceAreaName}'ye bağlı ${confirmedServiceNumber} kodlu ${confirmedServiceName} servisinin SAP’de açılması için yardımınızı rica ederiz.`
      : confirmServiceOpeningType == "Şube Açılışı"
        ? comment = `${confirmServiceAreaName}'ye bağlı ${confirmServiceDetailName} servisinin şubesi olarak ${confirmedServiceNumber} kodlu ${confirmedServiceName} açılacaktır. Yedek parça sevkiyat kodu ${confirmedShipmentCode}. SAP açılışı için yardımınızı rica ederiz.`
        : confirmServiceOpeningType == "Birleşme"
          ? comment = `${confirmServiceAreaName}'ye bağlı ${confirmServiceDetailName} servis(ler)i ${confirmServiceOpeningType} sebebiyle ${confirmedServiceNumber} kodlu ${confirmedServiceName} servisi olarak açılacaktır. SAP’de açılması için yardımınızı rica ederiz.`
          : comment = `${confirmServiceAreaName}'ye bağlı ${confirmServiceDetailName} servisi ${confirmServiceOpeningType} sebebiyle ${confirmedServiceNumber} kodlu ${confirmedServiceName} servisi olarak yeniden açılacaktır. SAP’de açılması için yardımınızı rica ederiz.`;

    comment = comment + "</br></br><b>Telefon: </b>" + confirmedServicePhone + "</br><b>Telefon2: </b>" + confirmedServicePhone2 + "</br><b>E-mail: </b>" + confirmedServiceEmail + "</br><b>Ys Sahibi E-mail: </b>" + confirmedServiceOwnerEmail + "</br>";

    const data = [{
      Id: selectedIndex,
      Yorum: comment,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      OpenType: openType,
      ServiceNumber: confirmedServiceNumber
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetArtemisPortalOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setConfirmPopUpWithServiceInformation(false);
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setConfirmPopUpWithServiceInformation(false);
        handleFileClose(1);
        setSelectedWorkOrderId([]);
        setSelectedYSOnay([]);
        setState({
          kural1: false,
          kural2: false,
          kural3: false,
          kural4: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleActionPopUp = (row) => {
    if (row.DURUM_ID == 5) {
      setSelectedIndex(row.ID);
      handleFileType(row.ID);
      setBYOnayPopUp(true);
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else if (row.DURUM_ID == 10) {
      setSelectedIndex(row.ID);
      setMoyOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else if(row.DURUM_ID == 14){
      setSelectedIndex(row.ID);
      setFinalPopUp(true);
      getApolloTodo();
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
  }

  const handleSinglePopUp = (row) => {
    if (row.DURUM_ID == 2 && row.ACILIS_TIP_ID != 5) {
      setSelectedIndex(row.ID);
      setDurumId(row.DURUM_ID);
      setFindeksPopUp(true);
      setFindeksYorumAciklama('');
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else if (row.DURUM_ID == 10 || (row.DURUM_ID == 5 && row.ACILIS_TIP_ID == 5)) {
      setSelectedIndex(row.ID);
      setConfirmServiceOpeningType(row.ACILIS_TIP);
      setConfirmServiceDetailName(row.SERVIS_DETAYLI_AD);
      setConfirmServiceAreaName(row.BOLGE_AD);
      setConfirmPopUpWithServiceInformation(true);
      //setYorumAciklama('.....ne bağlı ... kodlu .... servisinin SAP’de açılması için yardımınızı rica ederiz.');
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    // else if ((row.DURUM_ID == 5 && row.ACILIS_TIP_ID == 5)) {
    //   getMoyOnayText(row)
    // }
    else if (row.DURUM_ID == 14) {
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setDurumId(row.DURUM_ID);
      setYorumAciklama('');
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
    else {
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setYorumAciklama('');
      setDurumId(row.DURUM_ID);
      setOpenType(row.ACILIS_TIP_ID)
      setServiceType(row.SERVIS_TIP)
    }
  }

  const handleDocumentDownload = (row) => {
    setApplicationId(row.ID);
    setDocumentType(row.ACILIS_TIP_ID)
  }

  const handleFilePopUp = (row) => {
    setSelectedIndex(row.ID);
    getReceiptAllFiles(row.ID)
    setFilePopUp(true);
  }

  const handleYorum = (row) => {
    setSelectedIndex(row.ID);
    setTarihcePopUp(true);
  }

  const getReceiptAllFiles = (receiptNumber) => {
    setFileList([]);
    setLoading(true);
    if (!receiptNumber) {
      return;
    }
    var images = []
    axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 1).then(response => {
      setFileList(Array.isArray(response.data) ? response.data : [])
      setLoading(false)
    });
  }

  const getApolloTodo = () => {
    setLoading(true)
    axios.get("/GetApolloTodoList/1").then((response) => {
      const Todo = response.data;
      if (Todo.length === 0) {
        setTodoData([]);
        setLoading(false);
      } else {
        setTodoData(Todo);
        setLoading(false);
      }
    });
  }

  // const getMoyOnayText = (row) => {
  //   setLoading(true)
  //   axios.get("/GetMOYOnayText/" + row.ID).then((response) => {
  //     const text = response.data;
  //     if (text.length === 0) {
  //       setYorumAciklama('');
  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //       setYorumAciklama(text);
  //       setSelectedIndex(row.ID);
  //       setSinglePopUp(true);
  //       setDurumId(row.DURUM_ID);
  //       setOpenType(row.ACILIS_TIP_ID)

  //     }
  //   });
  // }

  const setCheckMenuItem = (id) => {
    if (checkedMenu?.includes(id)) {
      var checkedMenuControl = checkedMenu?.filter((item) => item !== id);
      setCheckedMenu(checkedMenuControl);
    }
    else {
      setCheckedMenu([...checkedMenu, id]);
    }
  }

  const setNewWindowOpen = (item) => {
    //get file data from GetReceiptFilesSpecial api
    setLoading(true);
    axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
      .then((response) => {
        const res = response.data[0];
        var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
        if (res?.DOSYA_TIPI?.includes('image')) {
          var image = new Image();
          image.src = FileData;
          var w = window.open("");
          if (!w) {
            return;
          }
          w.document.write(image.outerHTML);
          w.document.title = res.DOSYA_ADI;
          w.document.close();
        } else {
          var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
          openBlobInNewTab(blobData);
        }
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });

    // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
    // if (item?.DOSYA_TIPI?.includes('image')) {
    //   var image = new Image();
    //   image.src = FileData;
    //   var w = window.open("");
    //   w.document.write(image.outerHTML);
    //   w.document.title = item.DOSYA_ADI;
    //   w.document.close();
    // } else {
    //   var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
    //   openBlobInNewTab(blobData);
    // }
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    if (!newTab) {
      return;
    }
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleSaveTodoList = (itemValue) => {
    if (checkedMenu.length < todoData.length) {
      setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    const data = {
      ApplicationId: selectedIndex,
      Confirm: true,
      UserId: "",
      OpenCloseType: 1
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetTodoOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode == '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setFinalPopUp(false);
        handleFileClose(1);
      }
      if (res.ErrorCode == 0) {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setFinalPopUp(false);
        handleFileClose(1);
        setCheckedMenu([]);
      }
    }).catch(error => {
      setLoading(false);
      setFinalPopUp(false);
      handleFileClose(1);
    });
  }
  const handleFileType = (basvuruId) => {
    axios.get(`/GetFileTypeById/` + basvuruId)
      .then((response) => {
        const res = response.data;
        setFileTypeData(res);
      }).catch(error => {
      });
  }

  const handleReject = () => {
    if ((durumId == 2 && !findeksYorumAciklama && acilisTipId != 5)) {
      setRequired(true);
      return
    }
    if ((!yorumAciklama && durumId != 10 && durumId != 2)) {
      setRequired(true);
      return
    }

    var comment = '';
    if (durumId == 2) {
      comment = findeksYorumAciklama;
    }
    else if (durumId == 10) {
      comment = 'Moy tarafından reddedildi.';
    }
    else {
      comment = yorumAciklama;
    }
    const data = [{
      Id: selectedIndex,
      Yorum: comment,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      OpenType: openType
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetRejectBasvuru', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setFindeksPopUp(false);
        setConfirmPopUpWithServiceInformation(false)
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setFindeksPopUp(false);
        setConfirmPopUpWithServiceInformation(false)
        handleFileClose(1);
        setSelectedWorkOrderId([]);
        setSelectedYSOnay([]);
        setState({
          kural1: false,
          kural2: false,
          kural3: false,
          kural4: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
      setFindeksPopUp(false);
      setConfirmPopUpWithServiceInformation(false)
    });
  }

  const formatPhoneNumber = (inputValue) => {
    const cleaned = ('' + inputValue).replace(/\D/g, '');
    if (inputValue.length > 14) {
      return inputValue.substring(0, 16);
    }

    let formatted = '';
    for (let i = 0; i < cleaned.length; i++) {
      if (i === 0) {
        formatted += '(';
      } else if (i === 3) {
        formatted += ') ';
      } else if (i === 6) {
        formatted += ' - ';
      }
      formatted += cleaned.charAt(i);
    }

    return formatted;
  };

  const handlePhoneInputChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setConfirmedServicePhone(formattedValue);
  };

  const handlePhoneInputChange2 = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setConfirmedServicePhone2(formattedValue);
  };

  return (
    <Page sx={styles.root}>
      <Backdrop style={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}>
        </Alert>
      </Snackbar>
      <Container style={styles.container1} maxWidth="xl">
        <Card >
          <CardHeader
            title="Onay Bekleyenler"
            subheader={generalData.length ? `${filteredData.length} / ${generalData.length} kayıt` : undefined}
          />
          <Divider />
          <CardContent>
            <Grid container spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  size="small"
                  fullWidth
                  label="Ara"
                  placeholder="Bölge, il/ilçe, servis bilgisi..."
                  value={searchText}
                  onChange={(event) => setSearchText(event.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={bolgeSecenekleri}
                  value={filtreBolge}
                  onChange={(event, value) => setFiltreBolge(value)}
                  renderInput={(params) => <TextField {...params} label="Bölge" />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={servisTipiSecenekleri}
                  value={filtreServisTipi}
                  onChange={(event, value) => setFiltreServisTipi(value)}
                  renderInput={(params) => <TextField {...params} label="Servis Tipi" />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={acilisTipiSecenekleri}
                  value={filtreAcilisTipi}
                  onChange={(event, value) => setFiltreAcilisTipi(value)}
                  renderInput={(params) => <TextField {...params} label="Açılış Tipi" />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={durumSecenekleri}
                  value={filtreDurum}
                  onChange={(event, value) => setFiltreDurum(value)}
                  renderInput={(params) => <TextField {...params} label="Durum" />}
                />
              </Grid>
              {filtreAktifMi && (
                <Grid>
                  <Button size="small" startIcon={<ClearIcon />} onClick={filtreleriTemizle}>
                    Filtreleri Temizle
                  </Button>
                </Grid>
              )}
            </Grid>
            <TableContainer sx={{ maxHeight: 560, overflow: 'auto' }}>
              <Table stickyHeader aria-label="sticky table" size="small"  >
                <TableHead style={{ overflowWrap: 'break-word' }}>
                  <TableRow>
                    <TableCell align="left">AçılışTipi</TableCell>
                    <TableCell align="left">Son Onay Veren</TableCell>
                    <TableCell align="left">Onay Beklenen</TableCell>
                    <TableCell align="left">BölgeKoduAdı</TableCell>
                    <TableCell align="left">İl-İlçe</TableCell>
                    <TableCell align="left">ServisTipi</TableCell>
                    <TableCell align="left">Servis Bilgi</TableCell>
                    <TableCell align="left">Açılış Detayı</TableCell>
                    <TableCell align="left">Servis Konumu</TableCell>
                    <TableCell align="left">Findeks Yorumu</TableCell>
                    <TableCell align="left">Yorumlar</TableCell>
                    <TableCell align="left">Belgeler</TableCell>
                    <TableCell align="left">Aksiyonlar</TableCell>
                    <TableCell align="left">Onay/Red</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData?.length ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableRow key={row.ID ?? index}
                      style={row.ID === selectedIndex ? { backgroundColor: "rgba(255, 152, 0, 0.16)" }
                        : {}}
                    >
                      <TableCell align="left">{row.ACILIS_TIP}</TableCell>
                      <TableCell align="left">
                        {DURUM_RENK[row.DURUM_ID] ? (
                          <Chip
                            size="small"
                            label={row.DURUM}
                            sx={{
                              backgroundColor: DURUM_RENK[row.DURUM_ID].color,
                              color: '#fff',
                              fontWeight: 500
                            }}
                          />
                        ) : row.DURUM}
                      </TableCell>
                      <TableCell align="left">{row.SONRAKI_ADIM_ACIKLAMA}</TableCell>
                      <TableCell align="left">{row.BOLGE_AD}</TableCell>
                      <TableCell align="left">{row.IL_ILCE}</TableCell>
                      <TableCell align="left">{row.SERVIS_TIP}</TableCell>
                      <TableCell align="left">
                        <ExpandableComment
                          Comment={row.SERVIS_BILGI}
                          CommentLimit={100}
                          DarkColor={selectedIndex != row.ID ? false : true} />
                      </TableCell>
                      <TableCell align="left">{row.ACILIS_TIP_ID == 1 ? '-' :
                        row.ACILIS_TIP_ID == 2 ? <><b>Devir olan servis: </b> {row.DEVIR}</> :
                          row.ACILIS_TIP_ID == 3 ? <><b>Şirketleşen servis: </b> {row.SIRKETLESME}</> :
                            row.ACILIS_TIP_ID == 4 ? <><b>Birleşen servisler: </b> {row.BIRLESME}</> :
                              <><b>Şube Açan Servis: </b> {row.SUBELESME}</>}</TableCell>
                      <TableCell align="left">{row.SERVIS_KONUMU}</TableCell>
                      <TableCell align="left">{row.FINDEKS_YORUM}</TableCell>
                      <TableCell align="left">
                        <Tooltip title="Yorum Geçmişi">
                          <IconButton
                            size="small"
                            onClick={() => handleYorum(row)}
                            style={{ backgroundColor: '#19ecff', color: 'white' }}
                          >
                            <CommentOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="left">
                        <Tooltip title="Belgeler">
                          <IconButton
                            size="small"
                            onClick={() => handleFilePopUp(row)}
                            style={{ backgroundColor: '#FF7F00', color: 'white' }}
                          >
                            <AttachFileOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>


                      {(row.DURUM_ID == 5 || row.DURUM_ID == 10) && row.ACILIS_TIP_ID != 5 ?
                        <TableCell align="left">
                          <Tooltip title="Aksiyonlar">
                            <IconButton
                              size="small"

                              onClick={() => {
                                handleActionPopUp(row)
                                setState({
                                  kural1: false,
                                  kural2: false,
                                  kural3: false,
                                  kural4: false
                                });
                              }}
                              style={{ backgroundColor: '#FF4F00', color: 'white' }}
                            >
                              <ExtensionIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        :(row.DURUM_ID == 14)?
                        <TableCell align="left">
                        <Tooltip title="Aksiyonlar">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAcilisTipId(row.ACILIS_TIP_ID)
                              handleActionPopUp(row)
                            }}
                            style={{ backgroundColor: '#FF4F00', color: 'white' }}
                          >
                            <ExtensionIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                        :<TableCell align="left" />
                      }

                        <TableCell align="left">
                          <Tooltip title="Onayla / Reddet">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setAcilisTipId(row.ACILIS_TIP_ID)
                                handleSinglePopUp(row)
                              }}
                              style={{ backgroundColor: '#32CD32', color: 'white' }}
                            >
                              <DoneAllIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                    </TableRow>
                  )) : (
                    <TableRow>
                      <TableCell colSpan={15} align="center" style={{ padding: 32 }}>
                        {generalData.length
                          ? 'Filtrelere uyan kayıt bulunamadı.'
                          : (loading ? 'Kayıtlar yükleniyor...' : 'Onay bekleyen kayıt bulunmamaktadır.')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredData.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              labelRowsPerPage="Sayfa başı kayıt:"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
            />
          </CardContent>
          <Dialog
            open={singlePopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setSinglePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              Onayla &amp; Reddet
              <IconButton
                onClick={() => {
                  setSinglePopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <TextField
                size="small"
                id="desc"
                autoComplete="no"
                multiline
                error={yorumAciklama?.length > 0 ? false : Required}
                rows={10}
                value={yorumAciklama}
                onChange={(event) => setYorumAciklama(
                  event.target.value
                )}
                fullWidth
                label='Yorum'
                variant="outlined"
              />
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSave()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={confirmPopUpWithServiceInformation}
            fullWidth
            maxWidth="sm"
            onClose={() => setConfirmPopUpWithServiceInformation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              Servis Açılışı &ndash; Onayla &amp; Reddet
              <IconButton
                onClick={() => {
                  setConfirmPopUpWithServiceInformation(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Box
                component="span"
                m="{1}"
                style={styles.spanText}
                sx={{
                  display: 'block',
                  backgroundColor: (theme) => theme.palette.grey[50],
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 2,
                  p: 2
                }}
              >
                      {confirmServiceOpeningType == "Yeni Açılış" ?
                        <>
                          <b>{confirmServiceAreaName}</b>&apos;ye bağlı <input type="text" name="name" style={{ ...styles.textInput, width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu <input type="text" name="name" style={styles.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> servisinin SAP’de açılması için yardımınızı rica ederiz.
                        </>
                        : confirmServiceOpeningType == "Şube Açılışı" ?
                          <>
                            <b>{confirmServiceAreaName}</b>&apos;ye bağlı <b>{confirmServiceDetailName}</b> servisinin şubesi olarak <input type="text" name="name" style={{ ...styles.textInput, width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu  <input type="text" name="name" style={styles.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> açılacaktır. Yedek parça sevkiyat kodu <input type="text" name="name" style={{ ...styles.textInput, width: 100 }} onChange={(e) => setConfirmedShipmentCode(e.target.value)} autoComplete="new-password" />. SAP açılışı için yardımınızı rica ederiz.
                          </>
                          : confirmServiceOpeningType == "Birleşme" ?
                            <>
                              <b>{confirmServiceAreaName}</b>&apos;ye bağlı <b>{confirmServiceDetailName}</b> servis(ler)i <b>{confirmServiceOpeningType}</b> sebebiyle <input type="text" name="name" style={{ ...styles.textInput, width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu  <input type="text" name="name" style={styles.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> servisi olarak açılacaktır. SAP’de açılması için yardımınızı rica ederiz.
                            </>
                            :
                            <>
                              <b>{confirmServiceAreaName}</b>&apos;ye bağlı <b>{confirmServiceDetailName}</b> servisi <b>{confirmServiceOpeningType}</b> sebebiyle <input type="text" name="name" style={{ ...styles.textInput, width: 50 }} onChange={(e) => setConfirmedServiceNumber(e.target.value)} autoComplete="new-password" /> kodlu  <input type="text" name="name" style={styles.textInput} onChange={(e) => setConfirmedServiceName(e.target.value)} autoComplete="new-password" /> servisi olarak yeniden açılacaktır. SAP’de açılması için yardımınızı rica ederiz.
                            </>
                      }
                      <br />
                      <br />
                      <b>Telefon:</b>
                      <input type="text"
                        placeholder="(###) ###-####"
                        value={confirmedServicePhone}
                        style={{ ...styles.textInput2, width: 110 }}
                        onChange={handlePhoneInputChange}
                        autoComplete="new-password"
                      />
                      <br />
                      <b>Telefon 2 :</b>
                      <input type="text"
                        placeholder="(###) ###-####"
                        value={confirmedServicePhone2}
                        style={{ ...styles.textInput2, width: 110 }}
                        onChange={handlePhoneInputChange2}
                        autoComplete="new-password"
                      />
                      <br />
                      <span style={styles.emailFieldRow}>
                        <b style={styles.emailFieldLabel}>E-mail:</b>
                        <input type="text"
                          value={confirmedServiceEmail}
                          placeholder="OrnekMail@arcelik.com"
                          style={{ ...styles.textInput2, ...styles.emailInput }}
                          onChange={(e) => setConfirmedServiceEmail(e.target.value)}
                          autoComplete="new-password"
                        />
                      </span>
                      <br />
                      <span style={styles.emailFieldRow}>
                        <b style={styles.emailFieldLabel}>YS Sahibi E-mail:</b>
                        <input type="text"
                          value={confirmedServiceOwnerEmail}
                          placeholder="OrnekMail@arcelik.com"
                          style={{ ...styles.textInput2, ...styles.emailInput }}
                          onChange={(e) => setConfirmedServiceOwnerEmail(e.target.value)}
                          autoComplete="new-password"
                        />
                      </span>
                    </Box>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSaveWithServiceInformation()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={findeksPopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setFindeksPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              Findeks Onayla &amp; Reddet
              <IconButton
                onClick={() => {
                  setFindeksPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={1.5}>
                <Grid
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 12
                  }}>
                  <FormControl
                    fullWidth
                    size="small"
                    variant="outlined"
                  >
                    <Select
                      fullWidth
                      native
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={findeksInfo}
                      // disabled={readonly}
                      onChange={(event) => { setFindeksInfo(event.target.value) }}
                    >
                      <option value="0" defaultValue="0">Findeks Durumu Seçiniz!...</option>
                      <option value={1}>Risk Yok</option>
                      <option value={4}>Az Riskli</option>
                      <option value={2}>Riskli</option>
                      <option value={3}>Yüksek Riskli</option>
                    </Select>
                  </FormControl>
                  {FINDEKS_RENK[findeksInfo] && (
                    <Chip
                      size="small"
                      label={FINDEKS_RENK[findeksInfo].label}
                      sx={{
                        mt: 1,
                        backgroundColor: FINDEKS_RENK[findeksInfo].color,
                        color: '#fff',
                        fontWeight: 500
                      }}
                    />
                  )}
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 12
                  }}>
                  <TextField
                    size="small"
                    id="desc"
                    autoComplete="no"
                    multiline
                    error={findeksYorumAciklama?.length > 0 ? false : Required}
                    rows={3}
                    value={findeksYorumAciklama}
                    onChange={(event) => setFindeksYorumAciklama(
                      event.target.value
                    )}
                    fullWidth
                    label='Findeks Yorum'
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSaveFindeks(1)}
                aria-label="save"
                component="span"
                variant="contained"

                endIcon={<CheckCircleOutlineIcon />}
                style={{ backgroundColor: '#008000', color: 'white' }}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={filePopUp}
            onClose={() => setFilePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: {
                width: 480,
                height: 560,
                maxWidth: '90vw',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column'
              }
            }}
          >
            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
              {`Belgeler${fileList?.length ? ` (${fileList.length})` : ''}`}
              <IconButton
                onClick={() => setFilePopUp(false)}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ p: 0, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              {fileList?.length ? (
                <List sx={{ flex: 1, overflow: 'auto', py: 0 }}>
                  {fileList.map((item, index) => (
                    <React.Fragment key={item.DOSYA_ID}>
                      {index > 0 && <Divider component="li" />}
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => setNewWindowOpen(item)}>
                          <ListItemIcon>
                            <InsertDriveFileOutlinedIcon style={{ color: '#FF9800' }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={item.DOSYA_ADI}
                            secondary={item.ContentType}
                          />
                        </ListItemButton>
                      </ListItem>
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, color: 'text.secondary' }}>
                  {loading ? (
                    <>
                      <CircularProgress size={28} />
                      <Typography variant="body2">Dosyalar yükleniyor...</Typography>
                    </>
                  ) : (
                    <>
                      <FolderIcon fontSize="large" />
                      <Typography variant="body2">Dosya bulunmamaktadır.</Typography>
                    </>
                  )}
                </Box>
              )}
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                onClick={() => setFilePopUp(false)}
                color="secondary"
                variant="contained"
              >
                Kapat
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={tarihcePopUp}
            fullWidth
            maxWidth="lg"
            onClose={event => setTarihcePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
            <DialogContent>
              <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={1} />
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={event => setTarihcePopUp(false)}
                aria-label="upload picture"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={finalPopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setFinalPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              Süreci Sonlandır
              <IconButton
                onClick={() => {
                  setFinalPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Süreci sonlandırmadan önce aşağıdaki adımların tamamlandığını onaylayın.
              </Typography>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody>
                    {
                      todoData?.map((item) => (
                        <TableRow key={item.ID}>
                          <TableCell align="left" style={{ width: '50px' }}>
                            <FormControlLabel
                              value="top"
                              control={(
                                <Checkbox
                                  color="primary"
                                  checked={checkedMenu.includes(item?.ID) ? true : false}
                                  onChange={() => setCheckMenuItem(item?.ID)}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell align="left">
                            {item.ACIKLAMA}
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => setFinalPopUp(false)}
              >
                Vazgeç
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSaveTodoList()}
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Tamamla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={byOnayPopUp}
            fullWidth
            maxWidth="xl"
            PaperProps={{ sx: { width: '95vw', maxWidth: '1800px' } }}
            onClose={() => setBYOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              BY Onay Aksiyonlar
              <IconButton
                onClick={() => {
                  setBYOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 3
                  }}>
                  <FormControl component="fieldset" sx={styles.formControl}>
                    <FormLabel component="legend">
                      Servis açılış süreci için aşağıdaki adımları tamamladınız mı?
                    </FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                        }
                        label="Tabela temini için MOY ile görüşüldü mü?"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox checked={kural2} onChange={handleChange} name="kural2" />
                        }
                        label="Yetkili Servis Sözleşmesi MOY'a ulaştırılmak üzere kargoya verildi mi?"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox checked={kural3} onChange={handleChange} name="kural3" />
                        }
                        label="Yetkili servis adayının e-fatura kaydı tamamlandı mı?"
                      />
                      {(serviceType == "Ticari Servis") ? (
                        <FormControlLabel
                          control={
                            <Checkbox checked={kural4} onChange={handleChange} name="kural4" />
                          }
                          label="13905 Belgesi (F Gaz belgesi) alındı mı?/Alınması konusunda Yetkili Servis adayına bilgi verildi mi?" />
                      ) : null}
                    </FormGroup>
                    <FormHelperText>
                      İşlemleri tamamlamadan devam edemezsiniz!!
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 9
                  }}>
                  <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={3}
                    openClose={1} />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setBYOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={moyOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setMoyOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              MOY Onay Adımları
              <IconButton
                onClick={() => {
                  setMoyOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={4}
                openClose={1} />
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setMoyOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Divider />
        </Card>
      </Container>
    </Page >
  );
}

export default Confirm;
